export const VERIFIED = "verified";
export const PENDING = "pending";
export const NOT_VERIFIED = "not_verified";
